import { UserStatus as UserStatusEnum } from "@sinch/core/entities/serverEnums";
import { UserStatus } from "@sinch/types/sinch.types";
import { useTranslation } from "react-i18next";
import { useEntityProps } from "../utilsHooks";

/**
 * Single source of truth for how a user status looks in the app: label and color.
 *
 * Use these getters wherever a user status is shown.
 * Never hardcode its label and color in a component, change them here.
 * Every value is shown in the "Entity Identity/UserStatus" story.
 */
export const useUserStatus = () => {
  const { t } = useTranslation();

  /**
   * Mapping of user statuses to their display properties
   */
  const UserStatuses = {
    [UserStatusEnum.Confirmed]: {
      label: t("UserStatus.confirmed"),
      color: "#5cb85c",
    },
    [UserStatusEnum.Shell]: {
      label: t("UserStatus.shell"),
      color: "#F3565D",
    },
    [UserStatusEnum.Pending]: {
      label: t("UserStatus.pending"),
      color: "#dfba49",
    },
    [UserStatusEnum.Invited]: {
      label: t("UserStatus.invited"),
      color: "#dfba49",
    },
  } as Record<UserStatusEnum | UserStatus, { label: string; color: string }>;
  const getProp = useEntityProps(UserStatuses);

  const getUserStatusLabel = getProp<string>("label");
  const getUserStatusColor = getProp<string>("color");

  return { getUserStatusLabel, getUserStatusColor };
};
